export const Error = ({ message }: { message?: string }) => {
  return (
    <div className="text-red-700 border-2 border-red-700 p-2 mx-10">
      {message || "An error has occurred"}
    </div>
  )
}
